import type { OutcomeHueName } from './outcome-colors';

export function marketOutcomePalette(seed: number): readonly OutcomeHueName[] {
  const palette = MARKET_OUTCOME_PALETTES[seed % MARKET_OUTCOME_PALETTES.length];
  if (palette === undefined) throw new Error('marketOutcomePalette: missing palette');
  return palette;
}

// Opening pairs cross hue families; semantic anchors occupy the last slots.
const MARKET_OUTCOME_PALETTES: readonly (readonly OutcomeHueName[])[] = [
  ['blue', 'purple', 'yellow', 'green', 'sky', 'pink', 'orange', 'violet', 'teal', 'red'],
  ['green', 'pink', 'blue', 'purple', 'yellow', 'sky', 'orange', 'violet', 'teal', 'red'],
  ['yellow', 'blue', 'purple', 'green', 'sky', 'pink', 'orange', 'violet', 'teal', 'red'],
  ['sky', 'orange', 'blue', 'purple', 'yellow', 'green', 'pink', 'violet', 'teal', 'red'],
  ['green', 'violet', 'blue', 'purple', 'yellow', 'sky', 'pink', 'orange', 'teal', 'red'],
  ['yellow', 'purple', 'blue', 'green', 'sky', 'pink', 'orange', 'violet', 'teal', 'red'],
  ['green', 'purple', 'blue', 'yellow', 'sky', 'pink', 'orange', 'violet', 'teal', 'red'],
  ['violet', 'orange', 'blue', 'purple', 'yellow', 'green', 'sky', 'pink', 'teal', 'red'],
  ['orange', 'sky', 'blue', 'purple', 'yellow', 'green', 'pink', 'violet', 'teal', 'red'],
  ['pink', 'blue', 'purple', 'yellow', 'green', 'sky', 'orange', 'violet', 'teal', 'red'],
  ['orange', 'purple', 'blue', 'yellow', 'green', 'sky', 'pink', 'violet', 'teal', 'red'],
  ['violet', 'green', 'blue', 'purple', 'yellow', 'sky', 'pink', 'orange', 'teal', 'red'],
];
